// removed by extract-text-webpack-plugin
module.exports = {"scrollable":"statistic__scrollable-3O7Vl","grid":"statistic__grid-1yerm","gridContent":"statistic__gridContent-2SsQj","headerTop":"statistic__headerTop-1jL2B","headerLeft":"statistic__headerLeft-3SrqJ","row":"statistic__row-1qd6g","hidden":"statistic__hidden-1qTZB","cell":"statistic__cell-1EKEW","headerItem":"statistic__headerItem-2J_ek"};


//////////////////
// WEBPACK FOOTER
// ./components/account/statistic/statistic.css
// module id = 782
// module chunks = 0